import styled from "styled-components";

import * as Sticker from "ds/Sticker";

export const StickerRoot = styled(Sticker.Root)`
  margin-bottom: 0;
`;
